'use strict';

const _=require('pulsar-utils/dist-es6/_');
const{DataSet,Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const{ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ForecastRowDirective=class ForecastRowDirective extends BaseControllerBackedDirective{
get template(){return''}

get objectBindings(){return['forecast','alertRanges','currentTime']}

get $inject(){return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}

get controller(){return ForecastRowController}};let


ForecastRowController=class ForecastRowController extends ScheduleRowDirectiveController{
constructor($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){
super($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService);
}

_updateData(){
let newData=[];

const currentTime={
id:'current-time',
start:this.currentTime,
type:'point',
className:'current-time'};


const pastMask={
id:'past-mask',
start:this.currentBounds.start,
end:this.currentTime,
type:'range',
className:'past-mask'};


if(this.forecast&&this.alertRanges){
let expectedScenarioBounds;
if(_.exists(this.forecast.scenario)&&this.forecast.scenario.duties&&this.forecast.scenario.duties.length!==0){
newData.push({
id:'forecasted-duty',
start:this.forecast.scenario.duties[0].start,
end:this.forecast.scenario.duties[0].end,
className:`forecasted-duty`});

}

newData=newData.concat(
_getNamedRangesFrom(this.alertRanges.At,'at-threshold',_.noop),
_getNamedRangesFrom(this.alertRanges.Above,'above-threshold',_.noop),
_getNamedRangesFrom(this.forecast.schedule.trips,'trip',_formatTripLabel),
_getNamedRangesFrom(this.forecast.scenario.sleep,'sleep'),
_getNamedRangesFrom(this.forecast.schedule.duties,'duty'));


}

newData=_.compact([...newData,pastMask,currentTime]);

const idsToRemove=_.without(this._dataset.getIds(),...newData.map(d=>newData.id));
if(idsToRemove.length!==0){
this._dataset.remove(idsToRemove);
}

this._dataset.update(newData);
}

get currentBounds(){
return this._scheduleRowScrollingService.axisBounds;
}

static get DefaultTimelineOptions(){
return _timelineOptions;
}};


function _getNamedRangesFrom(data,name,titleFormatter=_formatBasicInterval){
if(!data){
return[];
}

return data.map((d,i)=>({
id:`${name}-${i}`,
start:d.start,
end:d.end,
title:titleFormatter(d),
className:name}));

}

function _formatTime(trip,key){
return Formatters.
formatInLocale(trip[key],`${Formatters.TwentyFourHourFormat} (Z)`,trip[key+'Timezone']).
replace(':00)',')');
}

function _formatBasicInterval(interval){
return`${_formatTime(interval,'start')} - ${_formatTime(interval,'end')}`;
}

function _formatTripLabel(trip){
return`${trip.origin.description} to ${trip.destination.description}<br/>${_formatTime(trip,'start')} - ${_formatTime(trip,'end')}`;
}

module.exports=ForecastRowDirective;
//# sourceMappingURL=forecastRowDirective.js.map
